// extracted by mini-css-extract-plugin
export var container = "_h2-0";
export var segment = "_h2-2";
export var segmentActive = "_h2-3";
export var track = "_h2-1";